export default {
  paymentFailed: 'Payment Failed',
  addNewCard: 'Add New Card',
  selectNewCard: 'Select New Card',
  newCardAdded: 'New Card Added',
  confirmPaymentCard: 'Confirm Payment',
  paymentSuccess: 'Payment Made Successfully'
};
